import { format } from 'date-fns/format';
import config from '../../../../../config';
import { removeComas, removePhoneCountryCode, removeWhiteSpaces } from '../../../../../utils/format';

export interface AuthToken {
  access_token: string;
  id_token?: string;
}

interface VerifiedUserData {
  address?: {
    streetWithNumber: string;
    postalCode: string;
    city: string;
  };
  familiyName?: string;
  givenName?: string;
  name?: string;
  phoneNumber?: string;
  birthdate?: string;
  email?: string;
}
export interface FormValues {
  email: string;
  mobilePhone: string;
  firstName: string;
  lastName: string;
  street: string;
  zip: string;
  birthDate: string;
  houseNumber: string;
  houseNoAlpha: string;
  city: string;
}

export const toFormValues = (verificationServiceResponse: VerifiedUserData): Partial<FormValues> => {
  const resp = verificationServiceResponse;
  return {
    street: removeComas(resp.address?.streetWithNumber || ''),
    zip: resp.address?.postalCode || '',
    city: resp.address?.city || '',
    lastName: resp.familiyName?.trim() || '',
    firstName: resp.givenName?.trim() || '', //or resp.name
    email: resp.email?.trim() || '',
    mobilePhone: removeWhiteSpaces(removePhoneCountryCode(resp.phoneNumber || '')),
    birthDate: resp.birthdate ? format(new Date(resp.birthdate), 'ddMMyy') : '',
  };
};

export const startCustomerVerification = async (providerName: string): Promise<string> => {
  return fetch(`${config.apiUrl}/customerverification/init?provider=${providerName}&callbackUrl=${location.origin}/callback`).then(
    (response) => response.text(),
  );
};

export const getAuthToken = async (code: string, providerName: string): Promise<AuthToken> => {
  const response = await fetch(
    `${config.apiUrl}/customerverification/getAuthToken?code=${code}&provider=${providerName}&callbackUrl=${location.origin}/callback`,
  );
  if (!response.ok) {
    throw new Error('Could not get verified user data');
  }
  return await response.json();
};

export const getVerifiedUserData = async (accessToken: string, providerName: string): Promise<VerifiedUserData | undefined> => {
  const response = await fetch(
    `${config.apiUrl}/customerverification/getVerifiedUserData?accessToken=${accessToken}&provider=${providerName}`,
  );
  if (!response.ok) {
    throw new Error('Could not get verified user data');
  }
  // handle response without body, this can happen for BankId at least in UAT
  if (response.status === 204) {
    return undefined;
  }
  try {
    return response.json();
  } catch (e) {
    console.error('Could not parse response', e);
    return undefined;
  }
};

export const registerContactKSButtonClick = (): Promise<string> => {
  return fetch(`${config.apiUrl}/customerverification/registerContactKSButtonClick`).then((response) => response.text());
};
